import Group from 'ol/layer/group'
import Tile from 'ol/layer/tile'
import SourceTileWMS from 'ol/source/tilewms'
import OSM from 'ol/source/osm'
import config from '@/config'

const { 
  geoserver: { geoserverURL, geoserverWorkspace },
} = config

const layersPNOAHistorico = [2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016].map(year => `PNOA${year}`)
const ortoMax = 'OI.OrthoimageCoverage'

const GEOSERVER_URL = `${geoserverURL}/${geoserverWorkspace}/wms`

export default [
  new Group({
    id: 'capas-base',
    name: 'Capas Base',
    visible: true,
    layers: [
      new Tile({
        name: 'OSM',
        source: new OSM({
          crossOrigin: 'anonymous',
        }),
        visible: true
      })
    ]
  }),

  // http://www.ign.es/wms-inspire/pnoa-ma
  // http://www.ign.es/wms/pnoa-historico
  new Group({
    name: 'Ortofotos',
    id: 'group-ortofotos',
    layers: [
      ...layersPNOAHistorico.map(name => new Tile({
        name,
        id: name,
        visible: false,
        source: new SourceTileWMS({
          url: 'https://www.ign.es/wms/pnoa-historico',
          crossOrigin: 'anonymous',
          attributions: '«PNOA cedido por © Instituto Geográfico Nacional de España»',
          params: {
            layers: name
          }
        })
      })),
      new Tile({
        id: name,
        name: 'PNOA máxima actualidad',
        visible: false,
        source: new SourceTileWMS({
          url: 'https://www.ign.es/wms-inspire/pnoa-ma',
          crossOrigin: 'anonymous',
          attributions: '«PNOA cedido por © Instituto Geográfico Nacional de España»',
          params: {
            layers: ortoMax
          }
        })
      })
    ]
  }),

  new Tile({
    name: 'Actuación',
    source: new SourceTileWMS({
      url: GEOSERVER_URL,
      crossOrigin: 'anonymous',
      params: {
        layers: 'actuacion'
      }
    })
  })
]


// WEBPACK FOOTER //
// ./src/components/defaultLayers.js